








































import CommonButton from '@/components/button/CommonButton.vue';
import CommonPromptDialog from '@/components/dialog/CommonPromptDialog.vue';
import Component from 'vue-class-component';
import {Mixins} from 'vue-property-decorator';
import {MakeEditorTableDialogRequest} from '@/model/CommonModel';
import '@/plugins/Modal';
import DialogEventsMixin from '@/components/dialog/DialogEventsMixin';
import DefaultFormMixin from '@/views/DefaultFormMixin';
import CommonValidators from '@/validator/CommonValidators';
import NumberInput from '@/components/input/NumberInput.vue';
import BooleanCheckboxInput from '@/components/input/BooleanCheckboxInput.vue';

@Component({
             components: {
               BooleanCheckboxInput,
               NumberInput,
               CommonButton,
               CommonPromptDialog,
             },
             mixins: [DialogEventsMixin, DefaultFormMixin],
           })
export default class MakeEditorTableDialog extends Mixins<DialogEventsMixin, DefaultFormMixin>(DialogEventsMixin, DefaultFormMixin) {
  private form = {
    data: {
      rows: 3,
      columns: 3,
      isWithHeaderRow: true
    },
    rules: {
      rows: [
        {validator: CommonValidators.required(this, 'message.makeEditorTableDialog.validationMessage'), trigger: 'change'}
      ],
      columns: [
        {validator: CommonValidators.required(this, 'message.makeEditorTableDialog.validationMessage'), trigger: 'change'}
      ],
    }
  };
  private dialogVisible: boolean = false;
  private off: () => void;

  private onConfirm: (rows: number, columns: number, isWithHeaderRow: boolean) => void | undefined;

  get isVisible() {
    return this.dialogVisible;
  }

  public mounted() {
    this.$modal
        .getEventBus()
        .$on('showMakeEditorTableDialog', (params: MakeEditorTableDialogRequest) => {
          this.show(params);
        });

    this.$modal.getEventBus().$on('hideMakeEditorTableDialog', () => this.cancel());
  }

  public onOpened() {
    const refs = (this.$refs.rows as any);
    if (refs && refs.focus instanceof Function) {
      refs.focus(100);
    }
  }

  public show(param: MakeEditorTableDialogRequest) {
    this.dialogVisible = true;
    this.onConfirm = param.onConfirm;
  }

  public confirm() {
    this.validation(() => this.submit());
  }

  public submit() {
    const { rows, columns, isWithHeaderRow } = this.form.data;

    this.onConfirm(rows, columns, isWithHeaderRow);
    this.hide();
  }

  public cancel() {
    this.hide();
  }

  public hide() {
    this.dialogVisible = false;
  }

  public onClosed() {
    this.form.data.rows = 3;
    this.form.data.columns = 3;
    this.form.data.isWithHeaderRow = true;
    if (this.off) {
      this.off();
    }
  }

  public destroyed() {
    this.$modal.getEventBus().$off('showMakeEditorTableDialog');
    this.$modal.getEventBus().$off('hideMakeEditorTableDialog');
  }
}
